module.exports = __webpack_public_path__ + "fonts/InstagramSans-Medium.35f4aff5.woff2";